import * as React from "react";
import { CSSProperties, FC, memo, useCallback } from "react";
import { Set } from "immutable";
import { List, ListItem } from "material-ui/List";
import Checkbox from "material-ui/Checkbox";
import Label from "./form/label";
import Dropdown from "./form/dropdown";

interface CurrencyMultiSelectProps {
    currencies: string[];
    selected: Set<string>;
    defaultCurrency?: string;
    label: string;
    onToggle(selected: Set<string>): void;
}

const styles: Record<string, CSSProperties> = {
    wrapper: {
        marginTop: "10px",
    },
};

export const CurrencyMultiSelect: FC<CurrencyMultiSelectProps> = ({
    // prettier please chop lines
    currencies,
    selected,
    defaultCurrency,
    label,
    onToggle,
}) => {
    const onCheck = useCallback(
        (currencyCode: string, event, checked: boolean) => {
            onToggle(checked ? selected.add(currencyCode) : selected.remove(currencyCode));
        },
        [onToggle, selected],
    );

    const selectedText = (
        defaultCurrency
            ? [defaultCurrency, ...selected.remove(defaultCurrency).toArray().sort()]
            : selected.toArray().sort()
    ).join(", ");

    return (
        <div style={styles.wrapper}>
            <Label>{label}</Label>
            <Dropdown label={selectedText}>
                <List>
                    {currencies.map((currencyCode) => (
                        <ListItem
                            key={currencyCode}
                            primaryText={currencyCode}
                            leftCheckbox={
                                <Checkbox
                                    onCheck={onCheck.bind(this, currencyCode)}
                                    checked={selected.includes(currencyCode)}
                                    disabled={defaultCurrency && currencyCode === defaultCurrency}
                                />
                            }
                        />
                    ))}
                </List>
            </Dropdown>
        </div>
    );
};

CurrencyMultiSelect.displayName = "CurrencyMultiSelect";

export default memo(CurrencyMultiSelect);
